import React, { useState, useEffect, useRef } from 'react';

import { content_language, translate } from '../../../../Utils';

import "./HomeSection_01.css"

const HomeSection = (props) => {

	const [, set_dados] = useState(null)
	const dados_config = useRef([])

    const [section_title, set_section_title] = useState(true);
    const [section_subtitle, set_section_subtitle] = useState(true);
    
    const [isloading, setLoading] = useState(true);
    
    const [color_primary, set_color_primary] = useState('');
    const [color_secondary, set_color_secondary] = useState('');

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [/*lang_id*/, set_lang_id] = useState('1');


    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
        }

        set_color_primary(dados_config.current.info.theme.info.color.primary)
        set_color_secondary(dados_config.current.info.theme.info.color.secondary)

        if(props.dados_component !== undefined && props.dados_component !== null && props.dados_component !== '') {
            
            if(props.dados_component.info.subtitle !== undefined && props.dados_component.info.subtitle !== null) {
                set_section_subtitle(translate(props.dados_component.info.subtitle, ''))
            }
            if(props.dados_component.info.title !== undefined && props.dados_component.info.title !== null) {
                set_section_title(translate(props.dados_component.info.title, ''))

                setLoading(false)
            }

        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

    }, [props, lang])

    return (
        isloading ?
            null
		:
            <table cellSpacing="0" cellPadding="0" align="center" className="es-content sct" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important' }}>
                <tbody>
                      <tr style={{ borderCollapse: 'collapse' }} >
                          <td align="center" style={{ padding: '0', margin: '0' }}>
                              <table cellSpacing="0" cellPadding="0" bgcolor="#ffffff" align="center" className="es-content-body" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: '#FFFFFF', width: '600px' }}>
                                  <tbody>   
                                      <tr style={{ borderCollapse: 'collapse' }} >
                                          <td align="left" style={{ margin: '0', paddingRight: '20px', paddingTop: '30px', paddingBottom: '15px', paddingLeft: '20px' }} >
                                              <table width="100%" cellSpacing="0" cellPadding="0" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                  <tbody>
                                                      <tr style={{ borderCollapse: 'collapse' }} >
                                                          <td valign="top" align="center" style={{ padding: '0', margin: '0', width: '560px' }} >
                                                              <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                                  <tbody>
                                                                      <tr style={{ borderCollapse: 'collapse' }} >
                                                                          <td align="center" style={{ padding: '0', margin: '0' }}>
                                                                              <h1 style={{ margin: '0', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '26px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '28px', color: color_primary }} >
                                                                                    <strong>
                                                                                        {section_title}
                                                                                    </strong>
                                                                              </h1>
                                                                          </td>
                                                                      </tr>
                                                                      <tr style={{ borderCollapse: 'collapse' }} >
                                                                          <td align="center" style={{ padding: '0', margin: '0' }}>
                                                                              <h2 style={{ margin:'0', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '21px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '28.8px', color: color_secondary }} > 
                                                                                  <strong>
                                                                                        <em>
                                                                                            {section_subtitle}
                                                                                        </em>
                                                                                  </strong>
                                                                              </h2>
                                                                          </td>
                                                                      </tr>
                                                                  </tbody>
                                                              </table>
                                                          </td>
                                                      </tr>
                                                  </tbody>
                                              </table>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </td>
                      </tr>
                </tbody>
            </table>
    )
};
export default HomeSection;